
import Splash from "../Pages/Splash";
import Home from "../Pages/Home/Home";
import Login from "../Pages/Auth/Login";
import VerifyOTP from "../Pages/Auth/VerifyOTP";
import UploadExcel from "../Pages/Products/UploadExcel";
import Agents from "../Pages/Vendors/Agents";
import ProductReport from "../Pages/Products/ProductReport";
import ProductProductionReport from "../Pages/Products/ProductProductionReport";
import BrandSaleReport from "../Pages/Products/BrandSaleReport";
import BrandSaleMonthReport from "../Pages/Products/BrandSaleMonthReport";
import VendorSaleReport from "../Pages/Products/VendorSaleReport";
import VendorSaleMonthReport from "../Pages/Products/VendorSaleMonthReport";
import SearchProduct from "../Pages/Products/SearchProduct";
import Orders from "../Pages/Orders/Orders";
import OrderDetails from "../Pages/Orders/OrderDetails";
import OrderBatteries from "../Pages/Orders/OrderBatteries";
import Pallet from "../Pages/Products/Pallet";
import ProductReportExcel from "../Pages/Products/ProductReportExcel";
import ReturnOrders from "../Pages/Orders/ReturnOrders";
import ROrderDetails from "../Pages/Orders/ROrderDetails";

import BOrders from "../Pages/Orders/BOrders";
import SBOrder from "../Pages/Orders/SBOrder";
import CreateReturn from "../Pages/Orders/CreateReturn";
import ROrderDetails2 from "../Pages/Vendors/ROrderDetails2";
import UploadExcelReturn from "../Pages/Products/UploadExcelReturn";
import ProductTracking from "../Pages/Products/ProductTracking";
import ProductProductionReportExcel from "../Pages/Products/ProductProductionReportExcel";
import SpecialProductReportExcel from "../Pages/Products/SpecialProductReportExcel";
import SpecialProductReport from "../Pages/Products/SpecialProductReport";
import ProductionProductReportExcel from "../Pages/Products/ProductionProductReportExcel";
import ReturnRequestCreate from "../Pages/Orders/ReturnRequestCreate";
import ReturnRequestList from "../Pages/Orders/ReturnRequestList";



const appRoutes = [
    {
        pageId : 1,
        path: "/",
        component: <Splash />,
    },
    {
        pageId : 2,
        path: "/login",
        component: <Login />,
    },
    {
        pageId : 3,
        path: "/verify",
        component: <VerifyOTP />,
    },
    {
        pageId : 4,
        path: "/home",
        component: <Home />,
    },
    {
        pageId : 5,
        path: "/batch-edit",
        component: <UploadExcel />,
    },
    {
        pageId : 6,
        path: "/agents",
        component: <Agents />,
    },
    {
        pageId : 7,
        path: "/batteries",
        component: <ProductReport />,
    },
    {
        pageId : 8,
        path: "/production",
        component: <ProductProductionReport />,
    },
    {
        pageId : 9,
        path: "/brand",
        component: <BrandSaleReport />,
    },
    {
        pageId : 10,
        path: "/brand-month",
        component: <BrandSaleMonthReport />,
    },
    {
        pageId : 11,
        path: "/vendor",
        component: <VendorSaleReport />,
    },
    {
        pageId : 12,
        path: "/vendor-month",
        component: <VendorSaleMonthReport />,
    },
    {
        pageId : 13,
        path: "/product/:code",
        component: <SearchProduct />,
    },

    {
        pageId : 14,
        path: "/orders",
        component: <Orders />,
    },

    {
        pageId : 15,
        path: "/orders/:id",
        component: <OrderDetails />,
    },
    {
        pageId : 16,
        path: "/order-batteries/:id",
        component: <OrderBatteries />,
    },
    {
        pageId : 17,
        path: "/pallet/:pallet",
        component: <Pallet />,
    },
    {
        pageId : 18,
        path: "/product-excel",
        component: <ProductReportExcel />,
    },
    {
        pageId : 19,
        path: "/return-orders",
        component: <ReturnOrders />,
    },
    {
        pageId : 20,
        path: "/return-orders/:id",
        component: <ROrderDetails />,
    },
    {
        pageId : 21,
        path: "/sb-orders",
        component: <BOrders />,
    },
    {
        pageId : 22,
        path: "/sb-orders/:id",
        component: <SBOrder />,
    },
    {
        pageId : 23,
        path: "/create-return",
        component: <CreateReturn />,
    },
    {
        pageId : 24,
        path: "/returned-orders/:id",
        component: <ROrderDetails2 />,
    },
    {
        pageId : 25,
        path: "/batch-return",
        component: <UploadExcelReturn />,
    },
    {
        pageId : 26,
        path: "/tracking",
        component: <ProductTracking />,
    },
    {
        pageId : 27,
        path: "/production-excel-report",
        component: <ProductProductionReportExcel />,
    },
    {
        pageId : 28,
        path: "/special",
        component: <SpecialProductReportExcel />,
    },

    {
        pageId : 29,
        path: "/sbatteries",
        component: <SpecialProductReport />,
    },

    {
        pageId : 30,
        path: "/productionReport",
        component: <ProductionProductReportExcel />,
    },

    {
        pageId : 31,
        path: "/return-request",
        component: <ReturnRequestCreate />,
    },

    {
        pageId : 32,
        path: "/return-requests",
        component: <ReturnRequestList  />,
    },

];
export default appRoutes;